export default __webpack_public_path__ + "base-osm-800-8d2a2f803abd7d39cc78a0a6d5834ae2.png";